import { useSuspenseQuery } from '@/hooks/use-suspense-query';

import { recipeTagApi } from './recipe-tag-api';

/**
 * Recipe tag query hooks using React Query
 */

export function useOrganisationTags(organisationId: string) {
  const { data, ...rest } = useSuspenseQuery(
    recipeTagApi.getOrganisationTags(organisationId),
  );

  return {
    data: data ?? [],
    ...rest,
  };
}

export function useRecipeTags(recipeId: string, organisationId: string) {
  const { data, ...rest } = useSuspenseQuery(
    recipeTagApi.getRecipeTags(recipeId, organisationId),
  );

  // Transform the data to extract just the recipe_tag objects
  const tags = data?.map((item) => item.recipe_tag) ?? [];

  return {
    data: tags,
    ...rest,
  };
}
